import { bootstrapApplication, createApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { provideHttpClient } from '@angular/common/http';
import { ConfigEnviromentService } from './app/core/service/configEnviroment.service';

(async () => {
  //console.log('🚀 Iniciando carga de configuración de entorno...');

  const app = await createApplication({
    providers: [provideHttpClient(), ConfigEnviromentService]
  });

  const configService = app.injector.get(ConfigEnviromentService);

  await configService.loadConfig();
  //console.log('✅ Configuración de entorno cargada');

  await bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [
      ...(appConfig.providers ?? []),
      { provide: ConfigEnviromentService, useValue: configService },
      provideHttpClient(),
    ],
  });
})();
